//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { InstagramSettingsModalActions } from '@account-settings/redux/facebook-instagram/instagram-settings-modal/instagramSettingsModalActions';
import {
  IInstagramSettingsModalState,
  INSTAGRAM_SETTINGS_MODAL_ACTIONS,
} from '@account-settings/redux/facebook-instagram/instagram-settings-modal/instagramSettingsModalModel';

const initialState: IInstagramSettingsModalState = {
  flags: {
    isFetchingAvailableAccounts: false,
    isOpen: false,
    isSavingSelectedAccount: false,
  },
  availableAccounts: {
    byId: {},
    orderedIds: [],
  },
  saveSelectedAccountError: undefined,
  selectedAccountId: undefined,
  selectedAccountIds: undefined,
  saveSelectedAccountErrors: undefined,
};

export default function InstagramSettingsModalReducer(
  state: IInstagramSettingsModalState = initialState,
  action: InstagramSettingsModalActions,
): IInstagramSettingsModalState {
  switch (action.type) {
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        flags: {
          ...state.flags,
          isOpen: true,
        },
        saveSelectedAccountError: initialState.saveSelectedAccountError,
        saveSelectedAccountErrors: initialState.saveSelectedAccountError,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        flags: {
          ...state.flags,
          isOpen: false,
        },
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.REQUEST_AVAILABLE_ACCOUNTS:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableAccounts: true,
        },
        availableAccounts: initialState.availableAccounts,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.RECEIVE_AVAILABLE_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableAccounts: false,
        },
        availableAccounts: action.availableAccounts,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.RECEIVE_AVAILABLE_ACCOUNTS_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailableAccounts: false,
        },
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.SET_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccountId: action.selectedAccountId,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.SET_SELECTED_ACCOUNTS:
      return {
        ...state,
        selectedAccountIds: action.selectedAccountIds,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.REQUEST_SAVE_SELECTED_ACCOUNT:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedAccount: true,
        },
        saveSelectedAccountError: initialState.saveSelectedAccountError,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.REQUEST_SAVE_SELECTED_ACCOUNTS:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedAccount: true,
        },
        saveSelectedAccountErrors: initialState.saveSelectedAccountError,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.RECEIVE_SAVE_SELECTED_ACCOUNT_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedAccount: false,
        },
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.RECEIVE_SAVE_SELECTED_ACCOUNT_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedAccount: false,
        },
        saveSelectedAccountError: action.message,
      };
    case INSTAGRAM_SETTINGS_MODAL_ACTIONS.RECEIVE_SAVE_SELECTED_ACCOUNTS_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedAccount: false,
        },
        saveSelectedAccountErrors: action.message,
      };
  }
  return state;
}
